export function Spacer({ height }) {
    return <div style={{ height: `${height !== undefined ? height : 10}px` }}></div>
}